module.exports = __webpack_public_path__ + "toGroom-we-g-b.6cb93cad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-g-b.jpg
// module id = z5DV
// module chunks = 0